function getCookie(name) {
    return document.cookie
        .split('; ')
        .find((r) => r.startsWith(name + '='))
        ?.split('=')[1];
}

// holt einmalig das XSRF Cookie (Laravel Sanctum/Web stack)
let csrfReady;

export async function ensureCsrf() {
    if (!csrfReady) {
        csrfReady = fetch('/sanctum/csrf-cookie', { credentials: 'same-origin' });
    }
    return csrfReady;
}

export async function postJSON(url, body) {
    await ensureCsrf();
    const xsrf = decodeURIComponent(getCookie('XSRF-TOKEN') || '');
    const res = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': xsrf
        },
        body: JSON.stringify(body)
    });
    if (!res.ok) {
        const text = await res.text();
        throw new Error(
            (() => {
                try {
                    return JSON.parse(text).message;
                } catch {
                    return text;
                }
            })() || 'Request failed'
        );
    }
    return res.json();
}
